import APIStates from 'enum/APIStates';
import { ENUM_FAVOURITE_STATUS, ENUM_FRIEND_STATUS } from 'enum/profile';
import { BROADCAST_STATUS } from 'enum/videoPlayer';


const profileStoreInitialState = {
  profileName: '',
  profileInfo: {},
  performerDetails: {},
  profileThumbnailUrl: '',
  performerFanClubInfo: {},
  performerGifts: [],
  performerInfoState: APIStates.INITIAL,
  performerFriendStatus: ENUM_FRIEND_STATUS.NONE,
  performerFavouriteStatus: ENUM_FAVOURITE_STATUS.NOT_FAVORITE,
  isLoadingPerformerFavouriteStatus: APIStates.INITIAL,
  broadcastStatus: BROADCAST_STATUS.UNKNOWN,
  favoritedCount: 0,
  friendsCount: 0,
  streamingInfo: {},
  privateMessageSendingStatus: APIStates.INITIAL,
  silenceList: [],
  profileNoIndexFollow: false,
  wishList: {},
  isUserReported: null,
  loggedInUserInfo: {},
  fbAuthData: null,
  currentUser: null,
  playToken: '',
  // private hls that directly updates from special calls like spy (works with playToken)
  privateHls: '',
  streamHasEndedState: false,
  privateShowReady: false,
  privateShowEnded: false,
  privateShowRequested: false,
  spyShowRequested: false,
  adminSpyShowRequested: false,
  adminSpyShowTime: 0,
  spyShowEnded: false,
  spyShowStartTime: null,
  privateShowStartTime: null,
  fullscreen: false,
  deviceInLandscape: false,
  broadcastingStarted: false,
  performerOnline: false,
  sexQuestionnaires: [],
  addFriendResponseStatus: APIStates.INITIAL,
  addFavoriteResponseStatus: APIStates.INITIAL,
  reportUserResponseStatus: APIStates.INITIAL,
  silenceUserResponseStatus: APIStates.INITIAL,
  awards: [],
  inCustomFullscreen: false,
  isChatConnected: false,
  isVideoStatsVisible: false,
  isMobileLoadingVisible: true,
  profileFeedbackResponseStatus: APIStates.INITIAL,
  feedbackImpression: null,
  reportInfoGETResponseStatus: APIStates.INITIAL,
  profileFeedbackSent: false,
  featuredCamStats: null,
  spyRequestInProgress: false,
  portraitTrueFullScreen: false,
  inTheatreMode: false,
  hideProfileStream: false,
  publicShowEnded: false,
  psGsLoading: APIStates.INITIAL,
  privateStreamingSources: null,
};

export default profileStoreInitialState;
